import { Tooltip } from 'antd';
import { EyeOutlined, DownloadOutlined, DeleteOutlined, EditOutlined, ContainerOutlined } from '@ant-design/icons';
import { StyledFileButton, StyledIconsWrapper } from './styles';

type FileActionConfig = {
    disabled?: boolean;
    tooltip?: string;
    onClick?: () => void;
};

type Props = {
    preview?: FileActionConfig;
    download?: FileActionConfig;
    edit?: FileActionConfig;
    delete?: FileActionConfig;
    archive?: FileActionConfig;
    unarchive?: FileActionConfig;
};

const FileActions = ({ preview, download, edit, delete: deleteAction, archive, unarchive }: Props) => {
    return (
        <StyledIconsWrapper>
            {preview?.onClick && (
                <Tooltip title={preview.tooltip ?? 'Preview'}>
                    <span>
                        <StyledFileButton
                            icon={<EyeOutlined />}
                            onClick={preview.onClick}
                            disabled={preview.disabled}
                        />
                    </span>
                </Tooltip>
            )}

            {archive?.onClick && (
                <Tooltip title={archive.tooltip ?? 'Archive'}>
                    <span>
                        <StyledFileButton
                            icon={<ContainerOutlined />}
                            onClick={archive.onClick}
                            disabled={archive.disabled}
                        />
                    </span>
                </Tooltip>
            )}

            {unarchive?.onClick && (
                <Tooltip title={unarchive.tooltip ?? 'Unarchive'}>
                    <span>
                        <StyledFileButton
                            icon={<ContainerOutlined />}
                            onClick={unarchive.onClick}
                            disabled={unarchive.disabled}
                        />
                    </span>
                </Tooltip>
            )}

            {download?.onClick && (
                <Tooltip title={download.tooltip}>
                    <span>
                        <StyledFileButton
                            icon={<DownloadOutlined />}
                            onClick={download.onClick}
                            disabled={download.disabled}
                        />
                    </span>
                </Tooltip>
            )}

            {edit?.onClick && (
                <Tooltip title={edit.tooltip}>
                    <span>
                        <StyledFileButton icon={<EditOutlined />} onClick={edit.onClick} disabled={edit.disabled} />
                    </span>
                </Tooltip>
            )}

            {deleteAction?.onClick && (
                <Tooltip title={deleteAction.tooltip}>
                    <span>
                        <StyledFileButton
                            icon={<DeleteOutlined />}
                            onClick={deleteAction.onClick}
                            disabled={deleteAction.disabled}
                        />
                    </span>
                </Tooltip>
            )}
        </StyledIconsWrapper>
    );
};

export default FileActions;
